export const selectSampleCoverageData = (state) => state.sampleCoverage?.sampleCoverageData;
export const selectLoading = (state) => state.sampleCoverage?.loading;
export const selectError = (state) => state.sampleCoverage?.error;
export const selectDistrictData = (state) => state.sampleCoverage?.districtData;
export const selectDistrictLoading = (state) => state.sampleCoverage?.districtLoading;
export const selectDistrictError = (state) => state.sampleCoverage?.districtError;
// Compliance selectors
export const selectComplianceData = (state) => state.sampleCoverage?.complianceData;
export const selectComplianceLoading = (state) => state.sampleCoverage?.complianceLoading;
export const selectComplianceError = (state) => state.sampleCoverage?.complianceError;